import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import AnimeQuizImg from "../../assets/event-images/animequiz.jpg";

const animeQuiz = {
  image: AnimeQuizImg,
  description:
    "The Anime Quiz Challenge is an exciting online trivia competition designed for anime enthusiasts. Participants will test their knowledge of anime series, movies, characters, and themes in a fun and competitive environment. With a mix of questions ranging from classics to modern hits, the quiz will engage participants of all levels of anime fandom.",
  type: "Non Technical Event",
  eventName: "Anime Quiz",
  dateTime: "Feb 28, 11:30AM - 01:00PM",
  venue: "IT-444",
  rules: [
    "Solo participation",
    "Points will be awarded based on the correctness and speed of answers. ",
    "Participants must ensure they do not use external help or resources during the quiz. ",
    "Cheating will lead to immediate disqualification.",
    "Each question will have a specific time limit to ensure fairness.",
  ],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Nandhana M",
      phoneNo: "9500756512",
    },
    {
      name: "Elankumaran K",
      phoneNo: "7604992336",
    },
  ],
};

const AnimeQuiz = () => {
  return <SingleEventPage eventDetails={animeQuiz} />;
};

export default AnimeQuiz;
